import axiosAutoCheck from "global/helpers/axiosAutoCheckIn";
import { PRESENTE, PRESENTE_FAIL, PRESENTE_SUCCESS } from "../ActionTypes";
import axiosLogin from "global/helpers/axiosLogin";

// Timeout máximo para la llamada de asignarPresente (ms). Si el backend tarda más,
// axios cancela y el flujo deriva a Punto de Control. Evita que el paciente se quede
// con un "falso presente" mientras la request queda colgada indefinidamente.
const ASIGNAR_PRESENTE_TIMEOUT_MS = 15000;

export const wsPostAsignarPresente =
  (idTurno, sectorTurno, nextStep) => (dispatch) => {
    dispatch({ type: PRESENTE });

    axiosLogin()
      .then((respuesta) => {
        respuesta
          .post(
            `/his/turnos/asignarPresente/${idTurno}/${sectorTurno}`,
            null,
            { timeout: ASIGNAR_PRESENTE_TIMEOUT_MS },
          )
          .then((resp) => {
            dispatch({ type: PRESENTE_SUCCESS, payload: resp.data });
            if (nextStep) nextStep(true);
          })
          .catch((err) => {
            const isTimeout = err?.code === "ECONNABORTED";
            console.error("[CheckinQR] asignarPresente FALLÓ", {
              idTurno,
              sectorTurno,
              isTimeout,
              status: err?.response?.status,
              error: err?.response?.data ?? err?.message,
            });
            const payload = isTimeout
              ? { detail: "La operación tardó demasiado. Acérquese al mostrador para confirmar el presente." }
              : err?.response?.data;
            dispatch({ type: PRESENTE_FAIL, payload });
            if (nextStep) nextStep(false, payload);
          });
      })
      .catch((err) => {
        console.error("[CheckinQR] axiosLogin falló en asignarPresente", {
          idTurno,
          error: err?.message,
        });
        dispatch({ type: PRESENTE_FAIL, payload: "Error de conexión" });
        if (nextStep) nextStep(false, err);
      });
  };

// export const wsPostAsignarPresente = (idTurno,sectorTurno,nextStep) => (dispatch) => {
//   dispatch({ type: PRESENTE });

//   axiosAutoCheck().then((respuesta) => {
//     respuesta
//       .post(`/asignarPresente/${idTurno}/${sectorTurno}`)
//       .then((resp) => {
//         dispatch({ type: PRESENTE_SUCCESS, payload: resp.data });
//         if (nextStep) nextStep(true);
//       })
//       .catch((err) => {
//         dispatch({ type: PRESENTE_FAIL, payload: err.response.data });
//         if (nextStep) nextStep(false);
//       });
//   });
// };
